import { __decorate } from "tslib";
import { property } from 'lit/decorators.js';
import { FormDataController } from './form-data.controller.js';
import { HelixValidatable } from './helix-validatable.js';
/**
 * In most cases, when you create a form control extend this class. It makes sure, your control will
 * participate in FormData creation and in form constraint validation.
 *
 * You have to implement a couple of abstract methods from `HelixValidatable`:
 * - {@link HelixValidatable.validity} (getter)
 * - {@link HelixValidatable.getDefaultErrorMessage}
 *
 * And all the stuff described in "Usage" section of  {@link ValidationController} which is
 * available for you as `this.validation` protected field.
 */
export class HelixFormControl extends HelixValidatable {
    constructor() {
        super();
        this.name = '';
        this.value = '';
        /** Is the form control required to be filled/checked */
        this.required = false;
        // FormDataController is never used below, however, since we are in a descendant
        // of LitElement, which implements ReactiveController, FormDataController _reacts_
        // on its lifecycle and that's how it handles `formdata` events.
        new FormDataController(this);
    }
}
__decorate([
    property({ type: String })
], HelixFormControl.prototype, "name", void 0);
__decorate([
    property({ type: String })
], HelixFormControl.prototype, "value", void 0);
__decorate([
    property({ type: Boolean })
], HelixFormControl.prototype, "required", void 0);
//# sourceMappingURL=helix-form-control.js.map